
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest, filter, first, map, tap } from 'rxjs';

import { Store } from '@ngrx/store';
import * as fromRouter from '../../reducers/router.reducer';

@Injectable()
export class BandSelectedGuard implements CanActivate {
    constructor(private store: Store, private router: Router) { }

    canActivate() {
        return this.store.select(fromRouter.getRouterBandId).pipe(
            map((bandId) => {
                if (bandId) {
                    return true;
                } else {
                    this.router.navigate(['/app/wrapper/band']);
                    return false;
                }
            })
        );
    }
}